import { isNil } from 'lodash'
import { useNavigate, useSearchParams } from 'react-router-dom'

import routes from '../../../routers'
import '../style.css'

const StepsComponent = ({ step = 0 }) => {
  const [paramsId] = useSearchParams()
  const navigation = useNavigate()
  const idGroup = !isNil(paramsId.get('id')) ? `?id=${paramsId.get('id')}` : ''

  const stepCircle = [
    { number: 1, title: 'Photo & details', link: `${routes.addRecipe}${idGroup}` },
    { number: 2, title: 'Ingredients', link: `${routes.addRecipeSecond}${idGroup}` },
    { number: 3, title: 'Steps', link: `${routes.addRecipeThird}${idGroup}` },
  ]

  return (
    <ol className="recipeStepper" aria-label={`Step ${step} of ${stepCircle.length}`}>
      {stepCircle.map(({ number, title, link }, index) => {
        const done = index < step - 1
        const current = index === step - 1
        return (
          <li
            key={number}
            className={`recipeStepperItem ${done ? 'done' : ''} ${current ? 'current' : ''}`}
          >
            {/* type="button": pressing Enter in a box "clicks" the form's first submit
                button, and this was it, so Enter jumped back to page 1 */}
            <button
              type="button"
              className="recipeStepperButton"
              aria-current={current ? 'step' : undefined}
              onClick={() => {
                if (step - 1 > index) {
                  navigation(link)
                }
              }}
            >
              <span className="recipeStepperNumber">{done ? '✓' : number}</span>
              <span className="recipeStepperTitle">{title}</span>
            </button>
          </li>
        )
      })}
    </ol>
  )
}

export default StepsComponent
